import { createEmbedChannel } from './channel'
import { sendChallengeOnCheckOrigin } from './eventHandlers/sendChallengeOnCheckOrigin'
import { sendNewTokenOnRefreshToken } from './eventHandlers/sendNewTokenOnRefreshToken'
import { appendSearchParamsIfSet } from './utils/appendSearchParamsIfSet'
import { authorize } from './utils/authorize'
import { createIframeWithLoader } from './utils/createIframeWithLoader'
import { displayError } from './utils/displayError'
import { getXundUrls } from './utils/getXundUrls'
import { getAttr } from './utils/utils'

export const embedTag = async (tag: HTMLScriptElement) => {
  const { webappBaseUrl, authBaseUrl } = getXundUrls({
    webappBaseUrl: tag.getAttribute('webapp-base-url'),
    authBaseUrl: tag.getAttribute('auth-base-url'),
  })

  const init = async function (clientId: string): Promise<void> {
    const XUND_WEBAPP_CODE = getAttr(tag, 'webapp-code') ?? ''

    const state = getAttr(tag, 'state')
    const checkId = getAttr(tag, 'checkId')

    const riskTopics = getAttr(tag, 'riskTopics')

    const birth = getAttr(tag, 'birth')
    const gender = getAttr(tag, 'gender')
    const weight = getAttr(tag, 'weight')
    const height = getAttr(tag, 'height')
    const age = getAttr(tag, 'age')
    const sex = getAttr(tag, 'sex')
    const language = getAttr(tag, 'app-language')
    const compactMode = getAttr(tag, 'compact-mode')
    const onboarding = getAttr(tag, 'onboarding')
    const xundInternal = getAttr(tag, 'xundInternal')
    const mockReport = getAttr(tag, 'mockReport')

    const { iframe, loader } = createIframeWithLoader(tag.parentNode as HTMLElement)

    const authCodeFromUrl = getAttr(tag, 'auth-code')

    const authCode = authCodeFromUrl ?? (await getAuthCode(authBaseUrl, tag, clientId, state))

    loader?.remove()

    const webappUrl = appendSearchParamsIfSet(`${webappBaseUrl}/${XUND_WEBAPP_CODE}`, {
      clientId,
      authCode,
      birth,
      gender,
      weight,
      height,
      age,
      sex,
      language,
      compactMode,
      riskTopics,
      onboarding,
      xundInternal,
      mockReport,
    })

    const channel = createEmbedChannel({
      sendTo: iframe.contentWindow as Window,
      origin: webappBaseUrl,
    })

    sendChallengeOnCheckOrigin(channel)
    sendNewTokenOnRefreshToken(channel, clientId, state, authBaseUrl)

    channel.subscribe('refresh', () => {
      channel.destroy()
      iframe.remove()
      init(clientId)
    })

    iframe.src = webappUrl.toString()
  }

  if (tag) {
    const clientId = tag.getAttribute('client-id')
    if (clientId) {
      await init(clientId)
    }
  }
}

const getAuthCode = async (authBaseUrl: string, tag: HTMLScriptElement, clientId: string, state: string | null) => {
  try {
    return await authorize({ url: authBaseUrl, clientId, state })
  } catch (e) {
    displayError(tag as HTMLElement, e instanceof Error ? e.message : String(e))
    throw e
  }
}
